import { getPath } from '@/router/common'

const baseUrl = {
  title: '基础模板管理',
  path: 'LibraryTemplate'
}

export default [
  {
    path: getPath('LibraryTemplateMana', baseUrl),
    name: 'LibraryTemplate_LibraryTemplateMana',
    component: () => import(/* webpackChunkName: "LibraryTemplate_LibraryTemplateMana" */ '@/views/libraryTemplate/libraryTemplateMana/index.vue'),
    meta: {
      title: '基础模板管理'
    }
  },
  {
    path: getPath('LibraryTemplateEdit', baseUrl),
    name: 'LibraryTemplate_LibraryTemplateEdit',
    component: () => import(/* webpackChunkName: "LibraryTemplate_LibraryTemplateEdit" */ '@/views/libraryTemplate/libraryTemplateEdit/index.vue'),
    meta: {
      title: '基础模板管理新增编辑'
    }
  }
]
